export const RamVariant = [
  { name: 4, value: 4 },
  { name: 6, value: 6 },
  { name: 8, value: 8 },
  { name: 12, value: 12 },
];
